const { SET_LOCATION } = require('./actions')
const RouterRecord = require('./record')

function routerReducer(state = new RouterRecord(), { type, payload }) {
  switch (type) {
    case SET_LOCATION:
      return state.setLocation(payload.location)
    default:
      return state
  }
}

module.exports = routerReducer
